import LabLandingPage from '../../components/LabLandingPage';
import { LAB_PAGES } from '../../content/labPages';

export default function CodeDebuggingTutorPage() {
  return <LabLandingPage page={LAB_PAGES.code} />;
}
